// extracted by mini-css-extract-plugin
module.exports = {"grid":"cd01fbf7b5--grid--PTXgq","large":"cd01fbf7b5--large--rBLD0"};